import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddComprStr = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_16783_51826)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6668 2.62695H5.00016C4.55814 2.62695 4.13421 2.80255 3.82165 3.11511C3.50909 3.42767 3.3335 3.85159 3.3335 4.29362V17.627C3.3335 18.069 3.50909 18.4929 3.82165 18.8055C4.13421 19.118 4.55814 19.2936 5.00016 19.2936H15.0002C15.4422 19.2936 15.8661 19.118 16.1787 18.8055C16.4912 18.4929 16.6668 18.069 16.6668 17.627V7.62695L11.6668 2.62695Z",
				stroke: "#004A96",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6665 2.62695V7.62695H16.6665",
				stroke: "#004A96",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 15.9609V10.9609",
				stroke: "#004A96",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.5 13.4609H12.5",
				stroke: "#004A96",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16783_51826",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(0 0.960938)"
		})
	}) })]
});
export default SvgAddComprStr;
